import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  screen: '',
  solutionData: {},
  prevScreen: '',
};

export const uiFactorySlice = createSlice({
  name: 'uiFactorySlice',
  initialState,
  reducers: {
    setScreen: (state, action) => {
        state.screen = action.payload && action.payload.screen;
        state.solutionData = action.payload && action.payload.solutionData;
        state.additionalData = action.payload && action.payload.additionalData;
        state.prevScreen = action.payload && action.payload?.prevScreen;
    },
    clearRemoveLocationsAdditionalData: state => {
        state.additionalData.showNotification = false;
        state.additionalData.notificationContent = false;
        state.additionalData.notificationType = false;
    }
  }
});

export const {
    setScreen,
    clearRemoveLocationsAdditionalData
} = uiFactorySlice.actions;

export default uiFactorySlice.reducer;
